import {
  LEADERBOARD_FILTERS_SCHEMA,
  MY_USER_FILTERS_SCHEMA,
  SORT_BY_TO_FILTERS_MAP,
  FILTERS_TO_SORT_BY_MAP,
} from '@app/shared/constants/friends';
import { SortBy, BalanceType } from '@app/shared/types/pages/friends';
import {
  LeaderboardSortTypeFilter,
  LeaderboardSortOrderFilter,
  LeaderboardFilters,
  MyUserFilters,
  LeaderboardUser,
} from '@app/store/slices/friends/friendsTypes';
import { UserListItemProps } from '@app/shared/ui/molecules/Friends';
import { defaultAvatarMale } from '@app/assets';

/* eslint-disable @typescript-eslint/no-unnecessary-condition, @typescript-eslint/no-unnecessary-type-parameters */
export const createFilterValidator =
  <
    TSchema extends Record<string, (value: unknown) => boolean>,
    TFilters extends Partial<Record<keyof TSchema, unknown>>,
  >(
    schema: TSchema
  ) =>
  <K extends keyof TSchema>(key: K, value: unknown): value is TFilters[K] =>
    schema[key]?.(value) ?? false;

export const isValidLeaderboardFilter = createFilterValidator<
  typeof LEADERBOARD_FILTERS_SCHEMA,
  LeaderboardFilters
>(LEADERBOARD_FILTERS_SCHEMA);

export const isValidMyUserFilter = createFilterValidator<
  typeof MY_USER_FILTERS_SCHEMA,
  MyUserFilters
>(MY_USER_FILTERS_SCHEMA);

export const getFiltersFromSortBy = (sortBy: SortBy) => SORT_BY_TO_FILTERS_MAP[sortBy];

export const getSortByFromFilters = (
  sortType: LeaderboardSortTypeFilter,
  sortOrder: LeaderboardSortOrderFilter
) => FILTERS_TO_SORT_BY_MAP[`${sortType}_${sortOrder}`];

export const mapLeaderboardUserToListItem = (
  user: LeaderboardUser,
  isMe: boolean,
  index: number,
  balanceType: BalanceType
): UserListItemProps => {
  const userName = user.profile?.fullName ?? user.telegramUsername ?? `Unknown #${String(user.id)}`;
  const userActivityTranslationKey = user.profile?.activitiesScope;
  const avatarUrl = user.profile?.avatar ?? defaultAvatarMale;
  const balanceMap = {
    [BalanceType.PANDA]: user.progress?.level ? user.progress.level + 1 : 1,
    [BalanceType.COOKIE]: Number(user.finance?.cookieWeeklyIncome ?? 0),
    [BalanceType.TON]: Number(user.finance?.tonWeeklyIncome ?? 0),
    [BalanceType.XP]: user.progress?.total_xp ?? 0,
  };
  const balance = balanceMap[balanceType];

  return {
    isMe,
    index,
    avatarUrl,
    userId: user.id,
    userName,
    userActivityTranslationKey,
    balance,
    balanceType,
  };
};

export const mapLeaderboardToUserList = (
  users: LeaderboardUser[],
  options: { balanceType: BalanceType; currentUserId?: number }
): UserListItemProps[] => {
  const { balanceType, currentUserId } = options;
  return users.map((user, index) =>
    mapLeaderboardUserToListItem(user, user.id === currentUserId, index, balanceType)
  );
};
